var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getPrimaryKey, parseFilters, getOrderBy, dataWithVirtualId, dataWithoutVirtualId, removePrimaryKey, getQuery, encodeId, } from './urlBuilder';
import qs from 'qs';
import { dequal as isEqual } from 'dequal';
export var defaultPrimaryKeys = new Map();
export var defaultSchema = function () { return ''; };
var useCustomSchema = function (schema, metaSchema, method) {
    var _a;
    var funcHeaderSchema = schema;
    if (metaSchema !== undefined) {
        funcHeaderSchema = function () { return metaSchema; };
    }
    if (funcHeaderSchema().length > 0) {
        var schemaHeader = '';
        if (['GET', 'HEAD'].includes(method)) {
            schemaHeader = 'Accept-Profile';
        }
        else if (['POST', 'PATCH', 'PUT', 'DELETE'].includes(method)) {
            schemaHeader = 'Content-Profile';
        }
        else
            return {};
        return _a = {}, _a[schemaHeader] = funcHeaderSchema(), _a;
    }
    else
        return {};
};
export default (function (config) { return ({
    getList: function (resource, params) {
        var _a, _b, _c, _d, _e, _f;
        if (params === void 0) { params = {}; }
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var _g = params.pagination, page = _g.page, perPage = _g.perPage;
        var _h = params.sort || {}, field = _h.field, order = _h.order;
        var _j = parseFilters(params, config.defaultListOp), filter = _j.filter, select = _j.select;
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        var query = __assign({ offset: String((page - 1) * perPage), limit: String(perPage) }, filter);
        if (field) {
            query.order = getOrderBy(field, order, primaryKey, config.sortOrder);
            if (((_b = params.meta) === null || _b === void 0 ? void 0 : _b.nullsfirst) &&
                !query.order.includes('nullsfirst')) {
                query.order = query.order.includes('nullslast')
                    ? query.order.replace('nullslast', 'nullsfirst')
                    : "".concat(query.order, ".nullsfirst");
            }
            if (((_c = params.meta) === null || _c === void 0 ? void 0 : _c.nullsfirst) === false &&
                query.order.includes('nullsfirst')) {
                query.order = query.order.replace('.nullsfirst', '');
            }
            if (((_d = params.meta) === null || _d === void 0 ? void 0 : _d.nullslast) && !query.order.includes('nullslast')) {
                query.order = query.order.includes('nullsfirst')
                    ? query.order.replace('nullsfirst', 'nullslast')
                    : "".concat(query.order, ".nullslast");
            }
            if (((_e = params.meta) === null || _e === void 0 ? void 0 : _e.nullslast) === false &&
                query.order.includes('nullslast')) {
                query.order = query.order.replace('.nullslast', '');
            }
        }
        if (select) {
            query.select = select;
        }
        // add header that Content-Range is in returned header
        var options = {
            headers: new Headers(__assign(__assign({ Accept: 'application/json', Prefer: 'count=exact' }, (((_f = params.meta) === null || _f === void 0 ? void 0 : _f.headers) || {})), useCustomSchema(config.schema, metaSchema, 'GET'))),
        };
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        return config.httpClient(url, options).then(function (_a) {
            var _b, _c, _d;
            var headers = _a.headers, json = _a.json;
            if (!headers.has('content-range')) {
                throw new Error("The Content-Range header is missing in the HTTP Response. The postgREST data provider expects\n          responses for lists of resources to contain this header with the total number of results to build\n          the pagination. If you are using CORS, did you declare Content-Range in the Access-Control-Expose-Headers header?");
            }
            var data = json.map(function (obj) { return dataWithVirtualId(obj, primaryKey); });
            var prefetched = getPrefetchedData(data, (_b = params.meta) === null || _b === void 0 ? void 0 : _b.prefetch);
            return {
                data: removePrefetchedData(data, (_c = params.meta) === null || _c === void 0 ? void 0 : _c.prefetch),
                total: parseInt(headers.get('content-range').split('/').pop(), 10),
                meta: ((_d = params.meta) === null || _d === void 0 ? void 0 : _d.prefetch) ? { prefetched: prefetched } : undefined,
            };
        });
    },
    getOne: function (resource, params) {
        var _a, _b;
        if (params === void 0) { params = {}; }
        var id = params.id, meta = params.meta;
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var query = getQuery(primaryKey, id, resource, meta);
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        return config
            .httpClient(url, {
            headers: new Headers(__assign(__assign({ accept: 'application/vnd.pgrst.object+json' }, (((_b = params.meta) === null || _b === void 0 ? void 0 : _b.headers) || {})), useCustomSchema(config.schema, metaSchema, 'GET'))),
        })
            .then(function (_a) {
            var _b, _c, _d;
            var json = _a.json;
            var data = dataWithVirtualId(json, primaryKey);
            var prefetched = getPrefetchedData(data, (_b = params.meta) === null || _b === void 0 ? void 0 : _b.prefetch);
            return {
                data: removePrefetchedData(data, (_c = params.meta) === null || _c === void 0 ? void 0 : _c.prefetch),
                meta: ((_d = params.meta) === null || _d === void 0 ? void 0 : _d.prefetch) ? { prefetched: prefetched } : undefined,
            };
        });
    },
    getMany: function (resource, params) {
        var _a;
        if (params === void 0) { params = {}; }
        var ids = params.ids;
        if (ids.length === 0) {
            return Promise.resolve({ data: [] });
        }
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var query = getQuery(primaryKey, ids, resource, params.meta);
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        return config
            .httpClient(url, {
            headers: new Headers(__assign({}, useCustomSchema(config.schema, metaSchema, 'GET'))),
        })
            .then(function (_a) {
            var _b, _c, _d;
            var json = _a.json;
            var data = json.map(function (data) {
                return dataWithVirtualId(data, primaryKey);
            });
            var prefetched = getPrefetchedData(data, (_b = params.meta) === null || _b === void 0 ? void 0 : _b.prefetch);
            return {
                data: removePrefetchedData(data, (_c = params.meta) === null || _c === void 0 ? void 0 : _c.prefetch),
                meta: ((_d = params.meta) === null || _d === void 0 ? void 0 : _d.prefetch) ? { prefetched: prefetched } : undefined,
            };
        });
    },
    getManyReference: function (resource, params) {
        var _a;
        var _b, _c;
        if (params === void 0) { params = {}; }
        var _d = params.pagination, page = _d.page, perPage = _d.perPage;
        var _e = params.sort, field = _e.field, order = _e.order;
        var _f = parseFilters(params, config.defaultListOp), filter = _f.filter, select = _f.select;
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var metaSchema = (_b = params.meta) === null || _b === void 0 ? void 0 : _b.schema;
        var query = params.target
            ? __assign((_a = {}, _a[params.target] = "eq.".concat(params.id), _a.order = getOrderBy(field, order, primaryKey, config.sortOrder), _a.offset = String((page - 1) * perPage), _a.limit = String(perPage), _a), filter) : __assign({ order: getOrderBy(field, order, primaryKey), offset: String((page - 1) * perPage), limit: String(perPage) }, filter);
        if (select) {
            query.select = select;
        }
        // add header that Content-Range is in returned header
        var options = {
            headers: new Headers(__assign(__assign({ Accept: 'application/json', Prefer: 'count=exact' }, (((_c = params.meta) === null || _c === void 0 ? void 0 : _c.headers) || {})), useCustomSchema(config.schema, metaSchema, 'GET'))),
        };
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        return config.httpClient(url, options).then(function (_a) {
            var _b, _c, _d;
            var headers = _a.headers, json = _a.json;
            if (!headers.has('content-range')) {
                throw new Error("The Content-Range header is missing in the HTTP Response. The postgREST data provider expects\n          responses for lists of resources to contain this header with the total number of results to build\n          the pagination. If you are using CORS, did you declare Content-Range in the Access-Control-Expose-Headers header?");
            }
            var data = json.map(function (data) { return dataWithVirtualId(data, primaryKey); });
            var prefetched = getPrefetchedData(data, (_b = params.meta) === null || _b === void 0 ? void 0 : _b.prefetch);
            return {
                data: removePrefetchedData(data, (_c = params.meta) === null || _c === void 0 ? void 0 : _c.prefetch),
                total: parseInt(headers.get('content-range').split('/').pop(), 10),
                meta: ((_d = params.meta) === null || _d === void 0 ? void 0 : _d.prefetch) ? { prefetched: prefetched } : undefined,
            };
        });
    },
    update: function (resource, params) {
        var _a, _b;
        if (params === void 0) { params = {}; }
        var id = params.id, data = params.data, meta = params.meta, previousData = params.previousData;
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var query = getQuery(primaryKey, id, resource, meta);
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        var changedData = getChanges(data, previousData);
        if (Object.keys(changedData).length === 0) {
            return Promise.resolve({ data: __assign({}, previousData) });
        }
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        var body = JSON.stringify(__assign({}, dataWithoutVirtualId(removePrimaryKey(changedData, primaryKey), primaryKey)));
        return config
            .httpClient(url, {
            method: 'PATCH',
            headers: new Headers(__assign(__assign({ Accept: 'application/vnd.pgrst.object+json', Prefer: 'return=representation', 'Content-Type': 'application/json' }, (((_b = params.meta) === null || _b === void 0 ? void 0 : _b.headers) || {})), useCustomSchema(config.schema, metaSchema, 'PATCH'))),
            body: body,
        })
            .then(function (_a) {
            var _b, _c, _d;
            var json = _a.json;
            var data = dataWithVirtualId(json, primaryKey);
            var prefetched = getPrefetchedData(data, (_b = params.meta) === null || _b === void 0 ? void 0 : _b.prefetch);
            return {
                data: removePrefetchedData(data, (_c = params.meta) === null || _c === void 0 ? void 0 : _c.prefetch),
                meta: ((_d = params.meta) === null || _d === void 0 ? void 0 : _d.prefetch) ? { prefetched: prefetched } : undefined,
            };
        });
    },
    updateMany: function (resource, params) {
        var _a, _b;
        if (params === void 0) { params = {}; }
        var ids = params.ids, meta = params.meta, data = params.data;
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var query = getQuery(primaryKey, ids, resource, meta);
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        var body = JSON.stringify(__assign({}, dataWithoutVirtualId(removePrimaryKey(data, primaryKey), primaryKey)));
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        return config
            .httpClient(url, {
            method: 'PATCH',
            headers: new Headers(__assign(__assign({ Prefer: 'return=representation', 'Content-Type': 'application/json' }, (((_b = params.meta) === null || _b === void 0 ? void 0 : _b.headers) || {})), useCustomSchema(config.schema, metaSchema, 'PATCH'))),
            body: body,
        })
            .then(function (_a) {
            var json = _a.json;
            return ({
                data: json.map(function (data) { return encodeId(data, primaryKey); }),
            });
        });
    },
    create: function (resource, params) {
        var _a, _b;
        if (params === void 0) { params = {}; }
        var meta = params.meta;
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var query = getQuery(primaryKey, undefined, resource, meta);
        var queryStr = qs.stringify(query);
        var url = "".concat(config.apiUrl, "/").concat(resource).concat(queryStr.length > 0 ? '?' : '').concat(queryStr);
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        return config
            .httpClient(url, {
            method: 'POST',
            headers: new Headers(__assign(__assign({ Accept: 'application/vnd.pgrst.object+json', Prefer: 'return=representation', 'Content-Type': 'application/json' }, (((_b = params.meta) === null || _b === void 0 ? void 0 : _b.headers) || {})), useCustomSchema(config.schema, metaSchema, 'POST'))),
            body: JSON.stringify(dataWithoutVirtualId(params.data, primaryKey)),
        })
            .then(function (_a) {
            var _b, _c, _d;
            var json = _a.json;
            var data = __assign(__assign({}, json), { id: encodeId(json, primaryKey) });
            var prefetched = getPrefetchedData(data, (_b = params.meta) === null || _b === void 0 ? void 0 : _b.prefetch);
            return {
                data: removePrefetchedData(data, (_c = params.meta) === null || _c === void 0 ? void 0 : _c.prefetch),
                meta: ((_d = params.meta) === null || _d === void 0 ? void 0 : _d.prefetch) ? { prefetched: prefetched } : undefined,
            };
        });
    },
    delete: function (resource, params) {
        var _a, _b;
        if (params === void 0) { params = {}; }
        var id = params.id, meta = params.meta;
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var query = getQuery(primaryKey, id, resource, meta);
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        return config
            .httpClient(url, {
            method: 'DELETE',
            headers: new Headers(__assign(__assign({ Accept: 'application/vnd.pgrst.object+json', Prefer: 'return=representation', 'Content-Type': 'application/json' }, (((_b = params.meta) === null || _b === void 0 ? void 0 : _b.headers) || {})), useCustomSchema(config.schema, metaSchema, 'DELETE'))),
        })
            .then(function (_a) {
            var _b, _c, _d;
            var json = _a.json;
            var data = dataWithVirtualId(json, primaryKey);
            var prefetched = getPrefetchedData(data, (_b = params.meta) === null || _b === void 0 ? void 0 : _b.prefetch);
            return {
                data: removePrefetchedData(data, (_c = params.meta) === null || _c === void 0 ? void 0 : _c.prefetch),
                meta: ((_d = params.meta) === null || _d === void 0 ? void 0 : _d.prefetch) ? { prefetched: prefetched } : undefined,
            };
        });
    },
    deleteMany: function (resource, params) {
        var _a, _b;
        if (params === void 0) { params = {}; }
        var ids = params.ids, meta = params.meta;
        var primaryKey = getPrimaryKey(resource, config.primaryKeys);
        var query = getQuery(primaryKey, ids, resource, meta);
        var url = "".concat(config.apiUrl, "/").concat(resource, "?").concat(qs.stringify(query));
        var metaSchema = (_a = params.meta) === null || _a === void 0 ? void 0 : _a.schema;
        return config
            .httpClient(url, {
            method: 'DELETE',
            headers: new Headers(__assign(__assign({ Prefer: 'return=representation', 'Content-Type': 'application/json' }, (((_b = params.meta) === null || _b === void 0 ? void 0 : _b.headers) || {})), useCustomSchema(config.schema, metaSchema, 'DELETE'))),
        })
            .then(function (_a) {
            var json = _a.json;
            return ({
                data: json.map(function (data) { return encodeId(data, primaryKey); }),
            });
        });
    },
}); });
var getChanges = function (data, previousData) {
    var changes = Object.keys(data).reduce(function (changes, key) {
        if (!isEqual(data[key], previousData[key])) {
            changes[key] = data[key];
        }
        return changes;
    }, {});
    return changes;
};
/**
 * Extract embeds from Postgrest responses
 *
 * When calling Postgrest database.getOne('posts', 123, { embed: 'tags' }),
 * the Postgrest response adds a `tags` key to the response, containing the
 * related tags. Something like:
 *
 *     { id: 123, title: 'React-query in details', tags: [{ id: 1, name: 'react' }, { id: 1, name: 'query' }] }
 *
 * We want to copy all the embeds in a data object, that will later
 * be included into the response meta.prefetched key.
 *
 * @example getPrefetchedData({ id: 123, title: 'React-query in details', tags: [{ id: 1, name: 'react' }, { id: 1, name: 'query' }] }, ['tags'])
 * // {
 * //   tags: [{ id: 1, name: 'react' }, { id: 1, name: 'query' }]
 * // }
 */
var getPrefetchedData = function (data, prefetchParam) {
    if (!prefetchParam)
        return undefined;
    var prefetched = {};
    var dataArray = Array.isArray(data) ? data : [data];
    prefetchParam.forEach(function (resource) {
        dataArray.forEach(function (record) {
            if (!prefetched[resource]) {
                prefetched[resource] = [];
            }
            var prefetchedData = Array.isArray(record[resource])
                ? record[resource]
                : [record[resource]];
            prefetchedData.forEach(function (prefetchedRecord) {
                if (prefetched[resource].some(function (r) { return r.id === prefetchedRecord.id; })) {
                    // do not add the record if it's already there
                    return;
                }
                prefetched[resource].push(prefetchedRecord);
            });
        });
    });
    return prefetched;
};
/**
 * Remove embeds from Postgrest responses
 *
 * When calling Postgrest database.getOne('posts', 123, { embed: 'tags' }),
 * the Postgrest response adds a `post` key to the response, containing the
 * related post. Something like:
 *
 *     { id: 123, title: 'React-query in details', tags: [{ id: 1, name: 'react' }, { id: 1, name: 'query' }] }
 *
 * We want to remove all the embeds from the response.
 *
 * @example removePrefetchedData({ id: 123, title: 'React-query in details', tags: [{ id: 1, name: 'react' }, { id: 1, name: 'query' }] }, 'tags')
 * // { id: 123, title: 'React-query in details' }
 */
var removePrefetchedData = function (data, prefetchParam) {
    if (!prefetchParam)
        return data;
    var dataArray = Array.isArray(data) ? data : [data];
    var newDataArray = dataArray.map(function (record) {
        var newRecord = {};
        for (var key in record) {
            if (!prefetchParam.includes(key)) {
                newRecord[key] = record[key];
            }
        }
        return newRecord;
    });
    return Array.isArray(data) ? newDataArray : newDataArray[0];
};
